/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { MemberManagementListMemberPointResponse } from './MemberManagementListMemberPointResponse';

export type MemberManagementListMemberPointResponseApiRespoonse = {
    data?: MemberManagementListMemberPointResponse;
    status?: MemberManagementListMemberPointResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace MemberManagementListMemberPointResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

